import { render, staticRenderFns } from "./underDevelopment.vue?vue&type=template&id=3e691929&"
import script from "./underDevelopment.vue?vue&type=script&lang=js&"
export * from "./underDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./underDevelopment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports